import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import DetailView from "@/views/DetailView.vue";
import MainVue from "@/views/MainVue.vue";
import IndustryView from "@/views/IndustryView.vue";
import QuestionAnswering from "@/views/QuestionAnswering.vue";
import ApiView from "@/views/ApiView.vue";

const routes = [

  {
    path: "/",
    name: "main",
    component: MainVue,
  },

  {
    path: "/video",
    name: "home",
    component: HomeView,
  },
  {
    path: "/facade",
    name: "DetailView",
    component: DetailView,
  },
  {
    path: "/qa",
    name: "QuestionAnswering",
    component: QuestionAnswering
  },
  {
    path: "/facade/:revsiteid/:dataid/:companyalias",
    name: "DetailView",
    component: DetailView,
  },
  {
    path: "/api/:revsiteid/:dataid/:companyalias",
    name: "ApiView",
    component: ApiView,
    meta: { layout: 'BlankTemplate' },
  },
  {
    path: "/industry/:groupname",
    name: "IndustryView",
    component: IndustryView,
  },


];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
